import intl from 'react-intl-universal'

import CONSTANTS from '~/constants'
import { storyLockedOrReadonlyAccessor } from '~/redux/appReducer'

function revisionsStandAloneController(
  revisionHistoryService,
  padlockService,
  storyService,
  toastr,
  uiStateManagerService,
  $rootScope,
  $location,
  $ngRedux,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  $httpParamSerializer
) {
  this.revisionLoading = false
  this.revisions = []
  this.storyId = null
  this.datetime = null
  this.revisions = []
  this.intl = intl

  const isLegacyEnabled = $rootScope.globalSettings?.openBeta?.legacyEnabled
  const runUnderEllipsisOne = () =>
    ~$location.absUrl().indexOf(CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI)

  this.leaveRevision = function leaveRevision() {
    if (runUnderEllipsisOne()) {
      const currentVersionOfStoryPath = $location
        .path()
        .split('/revision')[0]
        .replace('/story', '/edit')
        .slice(1)

      const redirectUrl = isLegacyEnabled
        ? `${currentVersionOfStoryPath}`
        : `${currentVersionOfStoryPath}?allowAngular=true`
      window.location.href = redirectUrl

      return
    }
    uiStateManagerService.triggerStateChange('revisions', {
      sender: {},
      action: {
        vertAction: 'revisions',
      },
      state: 'disabled',
      stateName: 'revisions',
      priority: 100,
      payload: {
        storyId: this.storyId || null,
      },
    })

    if (this.storyId !== null) {
      const currentVersionOfStoryPath = $location
        .path()
        .split('/revision')[0]
        .slice(1)

      const redirectUrl = isLegacyEnabled
        ? `${currentVersionOfStoryPath}`
        : `${currentVersionOfStoryPath}?allowAngular=true`
      window.location.href = redirectUrl
    }
  }.bind(this)
  const completeRestoration = function () {
    storyService.restoreRevision(this.currentRevisionId)
  }.bind(this)
  this.restoreRevision = function () {
    $rootScope.$broadcast('MODAL', {
      type: 'RESTORE_REVISION_MODAL',
      payload: {
        onSave: completeRestoration,
      },
    })
  }
  this.$onChanges = function revisionHeaderOnChanges(changesObj) {
    const newValue = changesObj.storyObj.currentValue
    if (
      // eslint-disable-next-line no-undef
      angular.isDefined(newValue) &&
      newValue._id &&
      newValue.diffViewRevisionId
    ) {
      this.datetime =
        newValue['rev' + newValue.diffViewRevisionId].last_updated_date

      this.storyId = newValue._id
      // padlock service returns false when non-stateful
      this.hasLock =
        padlockService.hasLock(newValue._id) ||
        !storyLockedOrReadonlyAccessor($ngRedux.getState())
      this.currentRevisionId = newValue.diffViewRevisionId || null
      this.revisionLoading = true
    }
  }
}

export default [
  'revisionHistoryService',
  'padlockService',
  'storyService',
  'toastr',
  'uiStateManagerService',
  '$rootScope',
  '$location',
  '$ngRedux',
  '$httpParamSerializer',
  revisionsStandAloneController,
]
